// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {CofidisLoanModalProps} from './types';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {config} from '../config';
import {containerTemplate, EVENT} from './container';

const options: ComponentOptionsType<CofidisLoanModalProps> = {
  tag: 'monei-cofidis-loan',
  url: config.cofidisLoanUrl,
  dimensions: {
    width: '100%',
    height: '100%'
  },
  autoResize: {
    width: false,
    height: false
  },
  prerenderTemplate: () => undefined,
  containerTemplate: containerTemplate,
  props: {
    paymentId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    amount: {
      type: zoid.PROP_TYPE.NUMBER,
      required: false
    },
    currency: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onSubmit: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onOpen: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onBeforeClose: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      default: ({event}: any) => {
        return () => {
          event.trigger(EVENT.BEFORE_CLOSE);
        };
      }
    }
  }
};

export const CofidisLoanModal: MoneiComponent<CofidisLoanModalProps> = zoid.create(options);
export const CofidisPayModal = CofidisLoanModal;
